// product slider
const swiperHintLottie = document.getElementById('swiper-hint-lottie');
const productSliderThumb = new Swiper(".product-slider-thumbnails", {
  spaceBetween: 10,
  slidesPerView: 5,
  freeMode: true,
  watchSlidesProgress: true,
  breakpoints: {
    900: {
      slidesPerView: 7,
      allowTouchMove: false,
    },
  }
});

const productSlider = new Swiper(".product-slider", {
  effect: 'fade',
  loop: true,
  fadeEffect: {
    crossFade: true
  },
  thumbs: {
      swiper: productSliderThumb,
  },
  breakpoints: {
    1100: {
      navigation: {
        nextEl: ".product-swiper-button-next",
        prevEl: ".product-swiper-button-prev",
      },
    },
  },
  on: {
    slideChange: function () {
        swiperHintLottie.stop();
        console.log('stoped');
    }
 }
});


// product-info-quantity

const toMore = document.getElementById('to-more-units');
const toLess = document.getElementById('to-less-units');
const quantityContainer = document.querySelector('.product-info-quantity');

if(toMore){
  toMore.addEventListener("click", (event) => {
    quantityContainer.classList.add('more');
  });
}
if(toLess){
  toLess.addEventListener("click", (event) => {
    quantityContainer.classList.remove('more');
  });
}
  
  
// color select

const productColorSelector = document.querySelectorAll('.product-color-selector');
const product_ID_Input = document.querySelector('input[name="product_id"]');
const colorSlide = {
  'color-blue': 0,
  'color-pink': 1,
  'color-green': 2
}

if(productColorSelector){
  productColorSelector.forEach((item) => {
      item.addEventListener('change', e => {
        var curColor = 'color-'+item.dataset.color;
        product_ID_Input.value = e.target.value;
        //console.log(e.target.value);
        changeColor(curColor);
        
      });
  });
}

addEventListener("DOMContentLoaded", (event) => {
  productColorSelector.forEach((item) => {
    if( item.checked ){
      //console.log(item.dataset.color);
      product_ID_Input.value = item.value;
      changeColor('color-'+item.dataset.color);
    }
  });
});

function changeColor(curColor){
  document.querySelectorAll('.luminette-3-quantity-bundle-image').forEach((el) => {
    if(el.classList.contains(curColor)){
      el.classList.add('color-active');
    }else{
      el.classList.remove('color-active');
    }
  });
  document.querySelectorAll('.product-slide-image-color').forEach((el) => {
    if(el.classList.contains(curColor)){
      el.classList.add('active');
    }else{
      el.classList.remove('active');
    }
  });
  document.querySelectorAll('.product-box-info-image').forEach((el) => {
    if(el.classList.contains(curColor)){
      el.classList.add('active');
    }else{
      el.classList.remove('active');
    }
  });
  productSlider.slideTo(colorSlide[curColor])
}
